import { IDTypeEnum } from '../../lib/types/enums/common/id-type.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCountryRequiredDocuments(id: number) {
  return restApiClient
    .url(constructApiUrl(API.countries.getCountryRequiredDocuments.url, { id }))
    .get<IDTypeEnum[]>()
}
